export const APP_NAME = 'The Students Visa'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const SCT_KEY = 'SCT-ID';